import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { faArrowLeft, faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function KalenderMobileContent() {
  const { t } = useTranslation();

  return (
    <div className="sticky top-0 z-10">
      <div className="flex items-start justify-between p-4">
        <div className="flex items-center gap-2">
          <Link
            to="/termine/uebersicht"
            aria-label={t('domain.termine.title')}
            title={t('domain.termine.title')}
            className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }))}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Link>
          <span className="font-semibold text-sm">
            {t('domain.termine.title')}
          </span>
        </div>
        <Button variant="default" size="icon" className="mt-2">
          <FontAwesomeIcon icon={faPlusLarge} className="font-bold" />
        </Button>
      </div>
    </div>
  );
}
